import styled from 'styled-components';

import {SimpleSpinnerLoader} from '~/shared/components/Loaders';
import {flexCenter} from '~/shared/theme/FlexLayout';
import {getLocalizationService} from '~/shared/services/localisationService';

import {Body, Disclaimer, TextBlock} from '../styled';

const Container = styled.div`
  ${flexCenter}
  flex: 1;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

const LoadingScreen = () => {
  const {t} = getLocalizationService();

  return (
    <Body data-test-id="convertLoyaltyBalanceModal_loadingScreen">
      <Container aria-live="polite" aria-busy="true">
        <SimpleSpinnerLoader variant="pieBig" data-test-id="convertLoyaltyBalanceModal_loader" />
        <TextBlock>
          <Disclaimer id="modal-title">{t('tap_and_save_convert_loading')}</Disclaimer>
        </TextBlock>
      </Container>
    </Body>
  );
};

export default LoadingScreen;
